import React from 'react';
import RecordsTable from './RecordsTable';
import { bankingMock } from './mockData';

const COLUMNS = [
  { field: 'BankDetailsId', header: 'ID' },
  { field: 'MemberID', header: 'Member ID' },
  { field: 'ActualPersonId', header: 'ActualPersonId' },
  { field: 'Account_Name', header: 'Account Name' },
  { field: 'Account_Number', header: 'Account_Number' },
  { field: 'Type_of_Account', header: 'Type Oof Account' },
  { field: 'StartDate', header: 'Start Date' },
];

const BankingDetailsTable = () => (
  <RecordsTable title="Banking Details" exportName="Banking Details" columns={COLUMNS} rows={bankingMock} />
);

export default BankingDetailsTable;
